import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { MerchantSearchState } from '../models/merchant.model';
import * as selectors from '../selectors/search.selectors';

@Injectable({ providedIn: 'root' })
export class MerchantSearchFacadeService extends FacadeService {
  constructor(public override store: Store<MerchantSearchState>) {
    super(store);
  }

  // OBSERVABLES
  panelExpanded$ = this.storeSelect(selectors.getPanelExpanded);
  companyValues$ = this.storeSelect(selectors.getCompanyValues);
  companyValuesFiltered$ = this.storeSelect(selectors.getCompanyValuesFiltered);
  companyName$ = this.storeSelect(selectors.getCompanyName);
  subscriptionPlanValues$ = this.storeSelect(selectors.getSubscriptionPlanValues);
  subscriptionPlan$ = this.storeSelect(selectors.getSubscriptionPlan);
  registrationDateFrom$ = this.storeSelect(selectors.getRegistrationDateFrom);
  getRegistrationDateFromText$ = this.storeSelect(selectors.getRegistrationDateFromText);
  registrationDateFromValidation$ = this.storeSelect(selectors.getImportDateFromValidation);
  qivosID$ = this.storeSelect(selectors.getQivosID);
  memberStatus$ = this.storeSelect(selectors.getMemberStatus);
  mainPageStatus$ = this.storeSelect(selectors.getMainPageStatus);
  editPageStatus$ = this.storeSelect(selectors.getEditPageStatus);
  disableSearch$ = this.storeSelect(selectors.getDisableSearch);
  seeMerchantCompanyNames$ = this.storeSelect(selectors.getCanSeeMerchantCompanyNames);
  viewMerchantSubscriptionPlans$ = this.storeSelect(selectors.getCanViewMerchantSubscriptionPlans);
  vatNumber$ = this.storeSelect(selectors.getVATNumber);
  vatNumberRegexValidation$ = this.storeSelect(selectors.getVATNumberRegexValidation);

  // OBSERVABLES VALUES
  get panelExpanded() {
    return this.storeSnapshot(this.panelExpanded$);
  }

  get getRegistrationDateFromText() {
    return this.storeSnapshot(this.getRegistrationDateFromText$);
  }

  get companyName() {
    return this.storeSnapshot(this.companyName$);
  }

  get qivosID() {
    return this.storeSnapshot(this.qivosID$);
  }

  get subscriptionPlan() {
    return this.storeSnapshot(this.subscriptionPlan$);
  }

  get memberStatus() {
    return this.storeSnapshot(this.memberStatus$);
  }

  get vatNumber() {
    return this.storeSnapshot(this.vatNumber$);
  }
}
